// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/picture/cancel.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/src/picture/Remote-Ex.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/src/picture/drone_white.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("/src/picture/icon_drone.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Header css */


:root {
    --bg-oficial: #b4a45b;
    --font-body: 'Kanit', sans-serif;
}

.activenav:hover {
    color: #69E4FF;
}

.bd-navbar {
    min-height: 0rem;
    background-color: var(--bg-oficial);
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, .05), inset 0 -1px 0 rgba(0, 0, 0, .1);
    padding-top: 2em;
    padding-bottom: .5em;

}

.title-navbar {
    font-family: var(--font-body);
    font-weight: 800;
    font-size: 45px;
}

.subtitle-section {
    color: var(--bg-oficial);
    font-family: var(--font-body);
    font-weight: 600;
    font-size: 25px;
}

.subtitle-card {
    font-family: var(--font-body);
    font-weight: 600;
    font-size: 25px;
}

.text-center {
    text-align: center;
}

.container-general {
    display: flex;
    align-items: center;
}

.section-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    border: 1px solid #c8c8c8;
}

.section-left {
    border-bottom-left-radius: 16px;
}

.section-right {
    border-bottom-right-radius: 16px;
}


.form-element {
    margin: 5px;
    min-width: 200px;
}

/*.form-control {
    width: 238px;
    display: block;
    border: 1px solid #C4B4B4;
    border-radius: 20px;
    height: 38px;
    padding: 5px 10px 5px 40px;
    
}*/

.form-box {
    width: 100%;
    max-width: 285px;
    border-radius: 10px;
}

.form-label {
    min-width: 150px;
    display: block;
    font-family: var(--font-body);
    font-weight: 600;
}

.form-input {
    display: inline-block;
    border: 1px solid #000000;
    border-radius: 10px;
    height: 40px;
    padding: 5px 10px 5px 15px;
}

.input .text input{
    -webkit-appearance: none;
    line-height: 24px;
    background: none;
    border: none;
    outline: none;
    display: block;
    width: 100%;
    margin: 0;
    padding: 12px 16px ;
    font-size: 14px;
    font-weight: 500;
    color: var(--text-color);
}
.input  .text
input::-moz-placeholder{
    color: var(--placeholder-color);
    -moz-transition: color 0.2s;
    transition: color 0.2s;
}
.input .clear svg{
    display: block;
    position: relative;
    z-index: 1; fill: none;
    width: 24px; height: 24px;
    outline: none;
    cursor: pointer;
    stroke-width: 1.5;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke:var(--close);
    transform: translateX(var(--clear-x)) rotate(var(--clear-rotate)translateZ(0));
}

.form-input-lg {
    display: inline-block;
    border: 1px solid #000000;
    border-radius: 10px;
    padding: 5px 10px 5px 15px;
    height: 50px;
    font-size: 24px;

}

.form-selection {
    display: inline-block;
    border: 1px solid #000000;
    border-radius: 10px;
    height: 40px;
    padding: 5px 10px 5px 15px;
    transition-delay: 2s;
    transition-duration: 1s;
}


.form-importf {
    width: 116.5px;
    font-size: 18px;
    border-radius: 10px;
    height: 40.5px;

}

.form-import-val {
    width: 100%;
    height: 40.5px;
    border-radius: 10px;
}

.font-icon {
    position: relative;

}

.font-icon i {
    position: absolute;
    left: 15px;
    top: 45px;
    color: #000;

}

.font-icon1 {
    font-size: 60px;


}

.btn-generate {
    border: none;
    border-radius: 10px;
    background-color: var(--bg-oficial);
    color: #fff;
    font-family: var(--font-body);
    font-weight: bold;
    padding: .5em;
    margin-top: 1em;
}

.id-card-container {
    display: none;
}

.card-container {
    width: 90vw;
    height: 300px;
    border-radius: 10px;
    font-family: var(--font-body);
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 500px;
}

.card-title {
    font-size: 16px;
    color: #BABFC9;
    font-weight: bold;
}

.card-input {
    font-size: 16px;
    color: #515A67;
    font-weight: bold;
}

.card-input1 {
    font-size: 28px;
    color: #515A67;
    font-weight: bold;
    padding: 5px 10px 5px 10px;


}

.card-wrapper {
    width: 80vw;
    height: 250px;
    background-color: #fff;
    background: linear-gradient(#f8f8f8, #fff);
    box-shadow: 0 8px 16px -8px rgba(0, 0, 0, 0.4);
    border-radius: 10px;
    overflow: hidden;
    position: relative;
    margin: 1.5rem;
    display: flex;
}

.user-card {
    width: 30vw;
    height: 100%;
    position: relative;
    background: linear-gradient(to top, var(--bg-oficial), #8f94fb);
    display: flex;
    justify-content: center;
    align-items: center;
}

.general-information {
    width: 60vw;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    background-color: #F8F8F8;
}

.user-photo {
    font-size: 10em;
    color: white;
}

.card-element {
    margin-left: 10px;
    margin-bottom: 15px;
}

.card-name {
    font-size: 1.5rem;
}

.college-name {
    font-size: 1.2rem;
}

.font-cen {
    font-Family: "Kanit";
    font-size: large;
}

.font-censize {
    font-Family: "Kanit";
    font-size: 18px;
}

.backgroundbase {
    /* background: linear-gradient(94.35deg, #023E8A 0%, #0077B6 100%); */
}

.build-button-border {

    padding: 1rem;
    position: relative;
    background: linear-gradient(101.27deg, #E01E37 0%, #FF792B 100%);
    padding: 3px;
}

.buildbutton {
    background: #E6E8EA;
    color: black;

}

.card-main {
    display: flex;
    background-color: #E6E8EA;
    border-style: solid;
    border-width: 1px;
    border-radius: 10px;
    border-color: #000000;
    width: 95%;
    height: auto;
    margin-top: auto;
    padding: 2%;
}

.text-red {
    color: red;
}


/* save Test */
body {
    width: 100%;
    margin: 0;
    padding: 0;
}

.container-main {
    background-color: #ffffff;
    /* Background color for the container */
    margin: 4%;
    padding: 2%;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
    margin-left: 10%;
    width: 80%;
    height: auto;
    background-image: linear-gradient(#E6E8EA, rgb(255, 255, 255));
    border-radius: 10px;


}

.form-section {
    padding: 5%;

}

.btn-sentgen {
    color: white;
    width: 300px;
    height: 87px;
    margin-top: 75px;
    margin-right: 50px;
    background: linear-gradient(101.27deg, #023E8A 0%, #0096C7 100%);
    border-radius: 27px;
    font-size: 31px;
    border-width: 0px;
    border-style: solid;
}

.Header-box {
    width: 75%;
    height: 50px;
    border-radius: 10px;
    margin-left: auto;
    box-shadow: 0px 2px 4px 1px rgba(0, 0, 0, 0.25);
    margin-right: auto;
    display: flex;
}

.box {
    /* Styles for the centered box */
    width: 90;
    height: 200px;
    background-color: #3498db;
    color: #fdfdfd;
    text-align: center;

    padding: 30px;
}

nav ul {
    list-style: none;
    padding: 0;

}

nav li {
    display: inline;
    margin-right: 20px;
}

nav a {
    text-decoration: none;
    color: #3498db;
    font-weight: bold;
    border-color: #000;
    padding-top: 50px;

}

.Header-RgD {
    width: 30%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #E6E8EA;
    border-radius: 10px;
    cursor: pointer;
    color: #3498db;
    font-weight: bold;
    font-size: large;
    /* Safari */
    transition-duration: 0.4s;
    text-decoration: none;
    overflow: hidden;
    cursor: pointer;
}

.Header-RgD:hover {
    width: 30%;
    height: 100%;
    display: flex;
    background: linear-gradient(90deg, #61028a76 0%, #5d00c783 100%);
    justify-content: center;
    align-items: center;
    cursor: pointer;
    color: #ffffff;
    font-weight: bold;
    font-size: large;
}

.Headered-RgD {
    width: 30%;
    height: 100%;
    padding: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: linear-gradient(90deg, #61028a 0%, #5d00c7 100%);
    box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    color: #ffffff;
    font-weight: bold;
    font-size: larger;
    /* Safari */
    transition-duration: 0.4s;
    text-decoration: none;
    overflow: hidden;
    cursor: pointer;
}

.Headered-RgD:hover {
    width: 30%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    color: #a6d5f5;
    
    font-weight: bold;
    font-size: large;
}


.container-box {
    background-color: red;
    width: 10%;
    height: 20%;
    padding: 40%;

}

h2.header-main {
    font-style: normal;
    font-size: 46px;
    color: #0077B6;
}
h3.header-main {
    font-style: normal;
    font-size: 39px;
    color: #0077B6;

}
h4.header-main{
    font-style: normal;
    font-size: 34px;
    color: #0077B6;
}

.normally-form {
    height: 35px;
    font-size: 18px;
    border: 1px solid;
    border-radius: 10px;
    color: black;
}


div.formtype-box {
    width: 100%;
    height: 80px;
    border-radius: 10px;
    border-width: 2px;
    border: outset;
    box-shadow: "0px 2px 4px 1px rgba(0, 0, 0, 0.25)";
    margin-right: auto;
    display: flex;
}


.btnEdit {
    color: #000;
    text-align: center;
    margin-left: 35px;
    font-weight: 400;
    line-height: 58px;
    font-size: 39px;
    background: linear-gradient(97.29deg, #FDC43F 0%, #FCEC5D 100%);
    border-radius: 79px;
    width: 120px;
    border: 0px solid;
}

.btnEdit:hover {
    background: linear-gradient(101.27deg, #ffcb9a 0%, #ff7c01 100%);
    color: #000;
}

.btnsentmsg {
    color: #FFFFFF;
    width: 300px;
    height: 87px;
    margin-top: 30px;
    background: linear-gradient(101.27deg, #023E8A 0%, #0096C7 100%);
    border-radius: 27px;
    font-size: 31px;
    border-width: 0px;
    border-style: solid;
    transition: 0.5s;
}

.btnsentmsg:hover {
    background: linear-gradient(101.27deg, #f8f548 0%, #f7d621 100%);
    color: #000;
    font-size: 33px;
}

.btn-switching {
    border-radius: 10px;
    width: 250px;
    height: 70px;
    font-size: 24px;
    margin-left: 35px;
    margin-top: 10px;
    transition: 0.1s;
    color: white;
    transition: 0.4s;
}
@keyframes twinkling {
    0% { opacity:0.3; }
    50%{opacity: 0.6; }
    100% { opacity: 0.99; }
  }
  
  .btn-twinkle{
    text-align: center;
    margin-right: 10px;
    background-color: #ff0000; 
    font-size: 14px;
    padding: 10px 20px; 
    font-size: 16px; 
    border: solid 3px rgba(0, 0, 0, 0.8) ;
    border-radius: 15px;
    cursor: pointer;
    animation: twinkling 1000ms infinite; 
  }
  .btn-twinkle:hover{
    background-color: #ffbb00; 
  }

.btn-switching:hover {
    font-size: 30px;
    color: #023E8A;
    width: 200px;
    transition-duration: 1s;
}

.btn-Delselection {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    margin-left: 10px;
    background-size: cover;
    background-repeat: no-repeat;
    width: 40px;
    height: 38px;
    border-color: transparent;
    border: 1px solid transparent;
    transition: 0.3s;
    transition-duration: 0.5s;
}

.btn-Delselection:hover {
    margin-left: 10px;
    background-size: cover;
    background-repeat: no-repeat;
    width: 32px;
    height: 30px;
}

.text-description {
    font-Family: "Kanit";
    font-size: medium;
    margin-left: 2.5px;
    color: gray;
    margin: auto;
}

a.custom-link {
    cursor: pointer;
    transition: 0.3s;
    transition-duration: 0.5s;
    border-radius: 10px;

}

a.custom-link:hover {
    background-color: rgb(70, 145, 141);
    border-radius: 10px;
}

.row-main {
    margin-top: "20px";
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    padding: "0px 10px";
    font-size: 28;
}

.remote-img {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-position: center center;
    margin-left: 10px;
    background-size: cover;
    width: 400px;
    height: 350px;
    border-radius: 15px;
}

.btn-Overlay-Trigger{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-size: cover;
    align-items: center;
    width: 20px;
    height: 20px;
    border: #000;
    transition: 0.5s;
}

.btn-Overlay-Trigger:hover{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    background-size: cover;
    width: 20px;
    height: 20px;
    border: #000;
    transition-duration: 1s;
}

Table.table-main{
    margin-top: 30px;
    width: 100%;
    height: auto;
    box-shadow: 0px 4px 7px 1px rgba(0, 0, 0, 0.25);
    font-size: 20px;
    text-align: center;
}

.table-card-header{
    display: flex;
    justify-content: center;
    align-items: center;
    margin: auto;
    margin-top:20px;
    background: linear-gradient(90deg, #61028a 0%, #5d00c7 100%);
    height: 86px;
    width: 75%;
    box-shadow: inset 2px 2px 2px 0px rgba(255, 255, 255, .5),
        7px 7px 20px 0px rgba(0, 0, 0, .1),
        4px 4px 5px 0px rgba(0, 0, 0, .1);
    border-radius: 10px;
    position: relative;
}

button.add-pilot{
    display: flex;
    background:linear-gradient(294deg, rgba(13,170,1,1) 0%, rgba(65,129,0,1) 100%);
    width: 150px;
    height: 50%;
    position: absolute;
    right: 50px;
    justify-content: center;
    align-items: center;
    border-radius: 15px;
    border:2px solid rgba(65,129,0,1);
    transition: all 0.25s ease;
    color: white;
}
.add-pilot:hover{
    border:2px solid rgb(255, 255, 255);
}

.force-fullscreen-modal {
  width: 100vw !important;
  max-width: 100vw !important;
  margin: 0 !important;
  padding: 0 !important;
}

.force-fullscreen-modal .modal-content {
  height: 100vh !important;
  width: 100% !important;
  padding: 0 !important;
  border-radius: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/Components/user/drone/Styles.css"],"names":[],"mappings":"AAAA,eAAe;;;AAGf;IACI,qBAAqB;IACrB,gCAAgC;AACpC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,mCAAmC;IACnC,8EAA8E;IAC9E,gBAAgB;IAChB,oBAAoB;;AAExB;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,wBAAwB;IACxB,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,gCAAgC;AACpC;;;AAGA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;;;;;;;;EAQE;;AAEF;IACI,WAAW;IACX,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;IACI,wBAAwB;IACxB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,cAAc;IACd,WAAW;IACX,SAAS;IACT,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,wBAAwB;AAC5B;AACA;;IAEI,+BAA+B;IAE/B,2BAAsB;IAAtB,sBAAsB;AAC1B;AACA;IACI,cAAc;IACd,kBAAkB;IAClB,UAAU,EAAE,UAAU;IACtB,WAAW,EAAE,YAAY;IACzB,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,sBAAsB;IACtB,mBAAmB;IACnB,8EAA8E;AAClF;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,mBAAmB;IACnB,0BAA0B;IAC1B,YAAY;IACZ,eAAe;;AAEnB;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,0BAA0B;IAC1B,oBAAoB;IACpB,uBAAuB;AAC3B;;;AAGA;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,cAAc;;AAElB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;;AAEtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,WAAW;;AAEf;;AAEA;IACI,eAAe;;;AAGnB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,mCAAmC;IACnC,WAAW;IACX,6BAA6B;IAC7B,iBAAiB;IACjB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,0BAA0B;;;AAG9B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,0CAA0C;IAC1C,8CAA8C;IAC9C,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,+DAA+D;IAC/D,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,qEAAqE;AACzE;;AAEA;;IAEI,aAAa;IACb,kBAAkB;IAClB,gEAAgE;IAChE,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,YAAY;;AAEhB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,qBAAqB;IACrB,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;;AAGA,cAAc;AACd;IACI,WAAW;IACX,SAAS;IACT,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,uCAAuC;IACvC,UAAU;IACV,WAAW;IACX,2CAA2C;IAC3C,gBAAgB;IAChB,UAAU;IACV,YAAY;IACZ,8DAA8D;IAC9D,mBAAmB;;;AAGvB;;AAEA;IACI,WAAW;;AAEf;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,gEAAgE;IAChE,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,+CAA+C;IAC/C,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,gCAAgC;IAChC,SAAS;IACT,aAAa;IACb,yBAAyB;IACzB,cAAc;IACd,kBAAkB;;IAElB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,UAAU;;AAEd;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;;AAErB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAEhB,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,aAAa;IACb,gEAAgE;IAChE,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,4DAA4D;IAC5D,2CAA2C;IAC3C,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IAEjB,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,cAAc;;IAEd,iBAAiB;IACjB,gBAAgB;AACpB;;;AAGA;IACI,qBAAqB;IACrB,UAAU;IACV,WAAW;IACX,YAAY;;AAEhB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,cAAc;;AAElB;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;AAChB;;;AAGA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;IACd,iDAAiD;IACjD,kBAAkB;IAClB,aAAa;AACjB;;;AAGA;IACI,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,+DAA+D;IAC/D,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,gEAAgE;IAChE,WAAW;AACf;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,gEAAgE;IAChE,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,gEAAgE;IAChE,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,KAAK,WAAW,EAAE;IAClB,IAAI,YAAY,EAAE;IAClB,OAAO,aAAa,EAAE;EACxB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,qCAAqC;IACrC,mBAAmB;IACnB,eAAe;IACf,oCAAoC;EACtC;EACA;IACE,yBAAyB;EAC3B;;AAEF;IACI,eAAe;IACf,cAAc;IACd,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,yDAAgD;IAChD,iBAAiB;IACjB,sBAAsB;IACtB,4BAA4B;IAC5B,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,6BAA6B;IAC7B,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,4BAA4B;IAC5B,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;;AAEvB;;AAEA;IACI,mCAAmC;IACnC,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,yDAAmD;IACnD,kCAAkC;IAClC,iBAAiB;IACjB,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,yDAAqD;IACrD,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,yDAAoD;IACpD,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,+CAA+C;IAC/C,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,4DAA4D;IAC5D,YAAY;IACZ,UAAU;IACV;;yCAEqC;IACrC,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8EAA8E;IAC9E,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,iCAAiC;IACjC,0BAA0B;IAC1B,YAAY;AAChB;AACA;IACI,mCAAmC;AACvC;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,qBAAqB;EACrB,2BAA2B;AAC7B","sourcesContent":["/* Header css */\r\n\r\n\r\n:root {\r\n    --bg-oficial: #b4a45b;\r\n    --font-body: 'Kanit', sans-serif;\r\n}\r\n\r\n.activenav:hover {\r\n    color: #69E4FF;\r\n}\r\n\r\n.bd-navbar {\r\n    min-height: 0rem;\r\n    background-color: var(--bg-oficial);\r\n    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, .05), inset 0 -1px 0 rgba(0, 0, 0, .1);\r\n    padding-top: 2em;\r\n    padding-bottom: .5em;\r\n\r\n}\r\n\r\n.title-navbar {\r\n    font-family: var(--font-body);\r\n    font-weight: 800;\r\n    font-size: 45px;\r\n}\r\n\r\n.subtitle-section {\r\n    color: var(--bg-oficial);\r\n    font-family: var(--font-body);\r\n    font-weight: 600;\r\n    font-size: 25px;\r\n}\r\n\r\n.subtitle-card {\r\n    font-family: var(--font-body);\r\n    font-weight: 600;\r\n    font-size: 25px;\r\n}\r\n\r\n.text-center {\r\n    text-align: center;\r\n}\r\n\r\n.container-general {\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.section-container {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    flex-direction: column;\r\n    border: 1px solid #c8c8c8;\r\n}\r\n\r\n.section-left {\r\n    border-bottom-left-radius: 16px;\r\n}\r\n\r\n.section-right {\r\n    border-bottom-right-radius: 16px;\r\n}\r\n\r\n\r\n.form-element {\r\n    margin: 5px;\r\n    min-width: 200px;\r\n}\r\n\r\n/*.form-control {\r\n    width: 238px;\r\n    display: block;\r\n    border: 1px solid #C4B4B4;\r\n    border-radius: 20px;\r\n    height: 38px;\r\n    padding: 5px 10px 5px 40px;\r\n    \r\n}*/\r\n\r\n.form-box {\r\n    width: 100%;\r\n    max-width: 285px;\r\n    border-radius: 10px;\r\n}\r\n\r\n.form-label {\r\n    min-width: 150px;\r\n    display: block;\r\n    font-family: var(--font-body);\r\n    font-weight: 600;\r\n}\r\n\r\n.form-input {\r\n    display: inline-block;\r\n    border: 1px solid #000000;\r\n    border-radius: 10px;\r\n    height: 40px;\r\n    padding: 5px 10px 5px 15px;\r\n}\r\n\r\n.input .text input{\r\n    -webkit-appearance: none;\r\n    line-height: 24px;\r\n    background: none;\r\n    border: none;\r\n    outline: none;\r\n    display: block;\r\n    width: 100%;\r\n    margin: 0;\r\n    padding: 12px 16px ;\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    color: var(--text-color);\r\n}\r\n.input  .text\r\ninput::-moz-placeholder{\r\n    color: var(--placeholder-color);\r\n    -moz-transition: color 0.2s;\r\n    transition: color 0.2s;\r\n}\r\n.input .clear svg{\r\n    display: block;\r\n    position: relative;\r\n    z-index: 1; fill: none;\r\n    width: 24px; height: 24px;\r\n    outline: none;\r\n    cursor: pointer;\r\n    stroke-width: 1.5;\r\n    stroke-linecap: round;\r\n    stroke-linejoin: round;\r\n    stroke:var(--close);\r\n    transform: translateX(var(--clear-x)) rotate(var(--clear-rotate)translateZ(0));\r\n}\r\n\r\n.form-input-lg {\r\n    display: inline-block;\r\n    border: 1px solid #000000;\r\n    border-radius: 10px;\r\n    padding: 5px 10px 5px 15px;\r\n    height: 50px;\r\n    font-size: 24px;\r\n\r\n}\r\n\r\n.form-selection {\r\n    display: inline-block;\r\n    border: 1px solid #000000;\r\n    border-radius: 10px;\r\n    height: 40px;\r\n    padding: 5px 10px 5px 15px;\r\n    transition-delay: 2s;\r\n    transition-duration: 1s;\r\n}\r\n\r\n\r\n.form-importf {\r\n    width: 116.5px;\r\n    font-size: 18px;\r\n    border-radius: 10px;\r\n    height: 40.5px;\r\n\r\n}\r\n\r\n.form-import-val {\r\n    width: 100%;\r\n    height: 40.5px;\r\n    border-radius: 10px;\r\n}\r\n\r\n.font-icon {\r\n    position: relative;\r\n\r\n}\r\n\r\n.font-icon i {\r\n    position: absolute;\r\n    left: 15px;\r\n    top: 45px;\r\n    color: #000;\r\n\r\n}\r\n\r\n.font-icon1 {\r\n    font-size: 60px;\r\n\r\n\r\n}\r\n\r\n.btn-generate {\r\n    border: none;\r\n    border-radius: 10px;\r\n    background-color: var(--bg-oficial);\r\n    color: #fff;\r\n    font-family: var(--font-body);\r\n    font-weight: bold;\r\n    padding: .5em;\r\n    margin-top: 1em;\r\n}\r\n\r\n.id-card-container {\r\n    display: none;\r\n}\r\n\r\n.card-container {\r\n    width: 90vw;\r\n    height: 300px;\r\n    border-radius: 10px;\r\n    font-family: var(--font-body);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    max-width: 500px;\r\n}\r\n\r\n.card-title {\r\n    font-size: 16px;\r\n    color: #BABFC9;\r\n    font-weight: bold;\r\n}\r\n\r\n.card-input {\r\n    font-size: 16px;\r\n    color: #515A67;\r\n    font-weight: bold;\r\n}\r\n\r\n.card-input1 {\r\n    font-size: 28px;\r\n    color: #515A67;\r\n    font-weight: bold;\r\n    padding: 5px 10px 5px 10px;\r\n\r\n\r\n}\r\n\r\n.card-wrapper {\r\n    width: 80vw;\r\n    height: 250px;\r\n    background-color: #fff;\r\n    background: linear-gradient(#f8f8f8, #fff);\r\n    box-shadow: 0 8px 16px -8px rgba(0, 0, 0, 0.4);\r\n    border-radius: 10px;\r\n    overflow: hidden;\r\n    position: relative;\r\n    margin: 1.5rem;\r\n    display: flex;\r\n}\r\n\r\n.user-card {\r\n    width: 30vw;\r\n    height: 100%;\r\n    position: relative;\r\n    background: linear-gradient(to top, var(--bg-oficial), #8f94fb);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.general-information {\r\n    width: 60vw;\r\n    height: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    background-color: #F8F8F8;\r\n}\r\n\r\n.user-photo {\r\n    font-size: 10em;\r\n    color: white;\r\n}\r\n\r\n.card-element {\r\n    margin-left: 10px;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.card-name {\r\n    font-size: 1.5rem;\r\n}\r\n\r\n.college-name {\r\n    font-size: 1.2rem;\r\n}\r\n\r\n.font-cen {\r\n    font-Family: \"Kanit\";\r\n    font-size: large;\r\n}\r\n\r\n.font-censize {\r\n    font-Family: \"Kanit\";\r\n    font-size: 18px;\r\n}\r\n\r\n.backgroundbase {\r\n    /* background: linear-gradient(94.35deg, #023E8A 0%, #0077B6 100%); */\r\n}\r\n\r\n.build-button-border {\r\n\r\n    padding: 1rem;\r\n    position: relative;\r\n    background: linear-gradient(101.27deg, #E01E37 0%, #FF792B 100%);\r\n    padding: 3px;\r\n}\r\n\r\n.buildbutton {\r\n    background: #E6E8EA;\r\n    color: black;\r\n\r\n}\r\n\r\n.card-main {\r\n    display: flex;\r\n    background-color: #E6E8EA;\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-radius: 10px;\r\n    border-color: #000000;\r\n    width: 95%;\r\n    height: auto;\r\n    margin-top: auto;\r\n    padding: 2%;\r\n}\r\n\r\n.text-red {\r\n    color: red;\r\n}\r\n\r\n\r\n/* save Test */\r\nbody {\r\n    width: 100%;\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\n.container-main {\r\n    background-color: #ffffff;\r\n    /* Background color for the container */\r\n    margin: 4%;\r\n    padding: 2%;\r\n    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);\r\n    margin-left: 10%;\r\n    width: 80%;\r\n    height: auto;\r\n    background-image: linear-gradient(#E6E8EA, rgb(255, 255, 255));\r\n    border-radius: 10px;\r\n\r\n\r\n}\r\n\r\n.form-section {\r\n    padding: 5%;\r\n\r\n}\r\n\r\n.btn-sentgen {\r\n    color: white;\r\n    width: 300px;\r\n    height: 87px;\r\n    margin-top: 75px;\r\n    margin-right: 50px;\r\n    background: linear-gradient(101.27deg, #023E8A 0%, #0096C7 100%);\r\n    border-radius: 27px;\r\n    font-size: 31px;\r\n    border-width: 0px;\r\n    border-style: solid;\r\n}\r\n\r\n.Header-box {\r\n    width: 75%;\r\n    height: 50px;\r\n    border-radius: 10px;\r\n    margin-left: auto;\r\n    box-shadow: 0px 2px 4px 1px rgba(0, 0, 0, 0.25);\r\n    margin-right: auto;\r\n    display: flex;\r\n}\r\n\r\n.box {\r\n    /* Styles for the centered box */\r\n    width: 90;\r\n    height: 200px;\r\n    background-color: #3498db;\r\n    color: #fdfdfd;\r\n    text-align: center;\r\n\r\n    padding: 30px;\r\n}\r\n\r\nnav ul {\r\n    list-style: none;\r\n    padding: 0;\r\n\r\n}\r\n\r\nnav li {\r\n    display: inline;\r\n    margin-right: 20px;\r\n}\r\n\r\nnav a {\r\n    text-decoration: none;\r\n    color: #3498db;\r\n    font-weight: bold;\r\n    border-color: #000;\r\n    padding-top: 50px;\r\n\r\n}\r\n\r\n.Header-RgD {\r\n    width: 30%;\r\n    height: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    background-color: #E6E8EA;\r\n    border-radius: 10px;\r\n    cursor: pointer;\r\n    color: #3498db;\r\n    font-weight: bold;\r\n    font-size: large;\r\n    -webkit-transition-duration: 0.4s;\r\n    /* Safari */\r\n    transition-duration: 0.4s;\r\n    text-decoration: none;\r\n    overflow: hidden;\r\n    cursor: pointer;\r\n}\r\n\r\n.Header-RgD:hover {\r\n    width: 30%;\r\n    height: 100%;\r\n    display: flex;\r\n    background: linear-gradient(90deg, #61028a76 0%, #5d00c783 100%);\r\n    justify-content: center;\r\n    align-items: center;\r\n    cursor: pointer;\r\n    color: #ffffff;\r\n    font-weight: bold;\r\n    font-size: large;\r\n}\r\n\r\n.Headered-RgD {\r\n    width: 30%;\r\n    height: 100%;\r\n    padding: 20px;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    background: linear-gradient(90deg, #61028a 0%, #5d00c7 100%);\r\n    box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.1);\r\n    border-radius: 10px;\r\n    color: #ffffff;\r\n    font-weight: bold;\r\n    font-size: larger;\r\n    -webkit-transition-duration: 0.4s;\r\n    /* Safari */\r\n    transition-duration: 0.4s;\r\n    text-decoration: none;\r\n    overflow: hidden;\r\n    cursor: pointer;\r\n}\r\n\r\n.Headered-RgD:hover {\r\n    width: 30%;\r\n    height: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    cursor: pointer;\r\n    color: #a6d5f5;\r\n    \r\n    font-weight: bold;\r\n    font-size: large;\r\n}\r\n\r\n\r\n.container-box {\r\n    background-color: red;\r\n    width: 10%;\r\n    height: 20%;\r\n    padding: 40%;\r\n\r\n}\r\n\r\nh2.header-main {\r\n    font-style: normal;\r\n    font-size: 46px;\r\n    color: #0077B6;\r\n}\r\nh3.header-main {\r\n    font-style: normal;\r\n    font-size: 39px;\r\n    color: #0077B6;\r\n\r\n}\r\nh4.header-main{\r\n    font-style: normal;\r\n    font-size: 34px;\r\n    color: #0077B6;\r\n}\r\n\r\n.normally-form {\r\n    height: 35px;\r\n    font-size: 18px;\r\n    border: 1px solid;\r\n    border-radius: 10px;\r\n    color: black;\r\n}\r\n\r\n\r\ndiv.formtype-box {\r\n    width: 100%;\r\n    height: 80px;\r\n    border-radius: 10px;\r\n    border-width: 2px;\r\n    border: outset;\r\n    box-shadow: \"0px 2px 4px 1px rgba(0, 0, 0, 0.25)\";\r\n    margin-right: auto;\r\n    display: flex;\r\n}\r\n\r\n\r\n.btnEdit {\r\n    color: #000;\r\n    text-align: center;\r\n    margin-left: 35px;\r\n    font-weight: 400;\r\n    line-height: 58px;\r\n    font-size: 39px;\r\n    background: linear-gradient(97.29deg, #FDC43F 0%, #FCEC5D 100%);\r\n    border-radius: 79px;\r\n    width: 120px;\r\n    border: 0px solid;\r\n}\r\n\r\n.btnEdit:hover {\r\n    background: linear-gradient(101.27deg, #ffcb9a 0%, #ff7c01 100%);\r\n    color: #000;\r\n}\r\n\r\n.btnsentmsg {\r\n    color: #FFFFFF;\r\n    width: 300px;\r\n    height: 87px;\r\n    margin-top: 30px;\r\n    background: linear-gradient(101.27deg, #023E8A 0%, #0096C7 100%);\r\n    border-radius: 27px;\r\n    font-size: 31px;\r\n    border-width: 0px;\r\n    border-style: solid;\r\n    transition: 0.5s;\r\n}\r\n\r\n.btnsentmsg:hover {\r\n    background: linear-gradient(101.27deg, #f8f548 0%, #f7d621 100%);\r\n    color: #000;\r\n    font-size: 33px;\r\n}\r\n\r\n.btn-switching {\r\n    border-radius: 10px;\r\n    width: 250px;\r\n    height: 70px;\r\n    font-size: 24px;\r\n    margin-left: 35px;\r\n    margin-top: 10px;\r\n    transition: 0.1s;\r\n    color: white;\r\n    transition: 0.4s;\r\n}\r\n@keyframes twinkling {\r\n    0% { opacity:0.3; }\r\n    50%{opacity: 0.6; }\r\n    100% { opacity: 0.99; }\r\n  }\r\n  \r\n  .btn-twinkle{\r\n    text-align: center;\r\n    margin-right: 10px;\r\n    background-color: #ff0000; \r\n    font-size: 14px;\r\n    padding: 10px 20px; \r\n    font-size: 16px; \r\n    border: solid 3px rgba(0, 0, 0, 0.8) ;\r\n    border-radius: 15px;\r\n    cursor: pointer;\r\n    animation: twinkling 1000ms infinite; \r\n  }\r\n  .btn-twinkle:hover{\r\n    background-color: #ffbb00; \r\n  }\r\n\r\n.btn-switching:hover {\r\n    font-size: 30px;\r\n    color: #023E8A;\r\n    width: 200px;\r\n    transition-duration: 1s;\r\n}\r\n\r\n.btn-Delselection {\r\n    background-image: url(\"/src/picture/cancel.png\");\r\n    margin-left: 10px;\r\n    background-size: cover;\r\n    background-repeat: no-repeat;\r\n    width: 40px;\r\n    height: 38px;\r\n    border-color: transparent;\r\n    border: 1px solid transparent;\r\n    transition: 0.3s;\r\n    transition-duration: 0.5s;\r\n}\r\n\r\n.btn-Delselection:hover {\r\n    margin-left: 10px;\r\n    background-size: cover;\r\n    background-repeat: no-repeat;\r\n    width: 32px;\r\n    height: 30px;\r\n}\r\n\r\n.text-description {\r\n    font-Family: \"Kanit\";\r\n    font-size: medium;\r\n    margin-left: 2.5px;\r\n    color: gray;\r\n    margin: auto;\r\n}\r\n\r\na.custom-link {\r\n    cursor: pointer;\r\n    transition: 0.3s;\r\n    transition-duration: 0.5s;\r\n    border-radius: 10px;\r\n\r\n}\r\n\r\na.custom-link:hover {\r\n    background-color: rgb(70, 145, 141);\r\n    border-radius: 10px;\r\n}\r\n\r\n.row-main {\r\n    margin-top: \"20px\";\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n    width: 100%;\r\n    padding: \"0px 10px\";\r\n    font-size: 28;\r\n}\r\n\r\n.remote-img {\r\n    background-image: url(\"/src/picture/Remote-Ex.png\");\r\n    background-position: center center;\r\n    margin-left: 10px;\r\n    background-size: cover;\r\n    width: 400px;\r\n    height: 350px;\r\n    border-radius: 15px;\r\n}\r\n\r\n.btn-Overlay-Trigger{\r\n    background-image: url(\"/src/picture/drone_white.png\");\r\n    background-size: cover;\r\n    align-items: center;\r\n    width: 20px;\r\n    height: 20px;\r\n    border: #000;\r\n    transition: 0.5s;\r\n}\r\n\r\n.btn-Overlay-Trigger:hover{\r\n    background-image: url(\"/src/picture/icon_drone.png\");\r\n    background-size: cover;\r\n    width: 20px;\r\n    height: 20px;\r\n    border: #000;\r\n    transition-duration: 1s;\r\n}\r\n\r\nTable.table-main{\r\n    margin-top: 30px;\r\n    width: 100%;\r\n    height: auto;\r\n    box-shadow: 0px 4px 7px 1px rgba(0, 0, 0, 0.25);\r\n    font-size: 20px;\r\n    text-align: center;\r\n}\r\n\r\n.table-card-header{\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    margin: auto;\r\n    margin-top:20px;\r\n    background: linear-gradient(90deg, #61028a 0%, #5d00c7 100%);\r\n    height: 86px;\r\n    width: 75%;\r\n    box-shadow: inset 2px 2px 2px 0px rgba(255, 255, 255, .5),\r\n        7px 7px 20px 0px rgba(0, 0, 0, .1),\r\n        4px 4px 5px 0px rgba(0, 0, 0, .1);\r\n    border-radius: 10px;\r\n    position: relative;\r\n}\r\n\r\nbutton.add-pilot{\r\n    display: flex;\r\n    background:linear-gradient(294deg, rgba(13,170,1,1) 0%, rgba(65,129,0,1) 100%);\r\n    width: 150px;\r\n    height: 50%;\r\n    position: absolute;\r\n    right: 50px;\r\n    justify-content: center;\r\n    align-items: center;\r\n    border-radius: 15px;\r\n    border:2px solid rgba(65,129,0,1);\r\n    transition: all 0.25s ease;\r\n    color: white;\r\n}\r\n.add-pilot:hover{\r\n    border:2px solid rgb(255, 255, 255);\r\n}\r\n\r\n.force-fullscreen-modal {\r\n  width: 100vw !important;\r\n  max-width: 100vw !important;\r\n  margin: 0 !important;\r\n  padding: 0 !important;\r\n}\r\n\r\n.force-fullscreen-modal .modal-content {\r\n  height: 100vh !important;\r\n  width: 100% !important;\r\n  padding: 0 !important;\r\n  border-radius: 0 !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
